import React, { useState } from "react";
import { DeleteFilled } from "@ant-design/icons";
import swal from "sweetalert";
import * as Yup from "yup";
import { ModalTitle } from "../../../modals/modals.components";
import { Form, Formik } from "formik";
import { Button, Col, Input, Row } from "antd";
import FormLabel from "../../../common/Form/FormLabel";
import { getIconForFileType } from "../../../layout/menu/CustomMenu";
import FormError from "../../../common/Form/FormError";
import ModalAlert from "../../../modals/Modal";
import {
  addFileModeleLM,
  updateFileModeleLM,
} from "../../../../data/bogClient";
import { cleanAndNormalizeName } from "../../../utilities/Utilities";

const FileUpdateUploaderModeleLN = ({
  handleVisibility,
  fetchData,
  client,
  visible,
  data,
}) => {
  const [loadingCreate, setLoadingCreate] = useState(false);
  const clientBogName = cleanAndNormalizeName(data.client_bo);

  const handleUploadUpdate = async (value) => {
    setLoadingCreate(true);
    value.id = data.id;
    const fileSizeLimit = 10 * 1024 * 1024;

    try {
      if (!value.selectedFiles) {
        // Cas sans fichier

        const response = await updateFileModeleLM(value);
        await swal(
          response.status === "success"
            ? "Opération effectuée avec succès"
            : response.message,
          "",
          response.status === "success" ? "success" : "error"
        );

        if (response.status === "success") {
          fetchData(clientBogName);
          handleVisibility();
        }
      } else {
        // Cas avec fichier
        const file = value.selectedFiles;

        if (!file) {
          await swal("Aucun fichier sélectionné", "", "error");
          return;
        }

        if (file.size > fileSizeLimit) {
          await swal("File size exceeds the limit", "", "error");
          return;
        }

        const formData = new FormData();
        formData.append("id", value.id);
        formData.append("file", file);
        formData.append("reference", value.reference);
        formData.append("libelle", value.libelle);
        formData.append("description", value.description);
        formData.append("size", file.size);
        formData.append("extension", file.name.split(".").pop().toLowerCase());
        formData.append("client_id", client?.id);

        try {
          const response = await updateFileModeleLM(formData);
          await swal(
            response.status === "success"
              ? "Opération effectuée avec succès"
              : response.message,
            "",
            response.status === "success" ? "success" : "error"
          );

          if (response.status === "success") {
            fetchData(clientBogName);
            handleVisibility();
          }
        } catch (error) {
          await swal(`Failed to upload file: ${file.name}`, "", "error");
        }
      }
    } catch (error) {
      await swal("Erreur du serveur", error);
    } finally {
      setLoadingCreate(false);
    }
    /* for (const file of value.selectedFiles) {
      if (file.size <= fileSizeLimit) {
        const extension = file.name.split(".").pop().toLowerCase();

        const formData = new FormData();
        formData.append("id", value.id);
        formData.append("file", file);
        formData.append("reference", value.reference);
        formData.append("libelle", value.libelle);
        formData.append("description", value.description);
        formData.append("size", file.size);
        formData.append("extension", extension);
        formData.append("client_id", client?.id);
        try {
          const response = await addFileModeleLM(formData);
          if (response.status === "success") {
            await swal("Opération effectuée avec succès", "", "success");
            fetchData(client?.id);
            handleVisibility();
            setLoadingCreate(false);
          } else {
            await swal(response.message, "", "error");
            setLoadingCreate(false);
          }
        } catch (error) {
          await swal("Failed to upload file: " + file.name, "", "error");
          setLoadingCreate(false);
        }
      } else {
        setLoadingCreate(false);
        await swal("File size exceeds the limit", "", "error");
      }
    } */
  };

  const dataValidationScheme = Yup.object({
    selectedFiles: Yup.mixed()
      .nullable()
      .test("fileSize", "Le fichier doit être inférieur à 10MB", (value) => {
        if (!value) return true;
        return value.size <= 10 * 1024 * 1024;
      }),
    /* .test(
        "fileType",
        "Format invalide (xlsx, csv, xls uniquement)",
        (value) => {
          if (!value || !(value instanceof File)) return true; // ✅ Ignore si aucun fichier
          const extension = value.name?.split(".").pop().toLowerCase();
          return ["xlsx", "csv", "xls"].includes(extension);
        }
      ), */
    reference: Yup.string().required("La référence du fichier est obligatoire"),
    libelle: Yup.string().required("Le nom du fichier est obligatoire"),
    description: Yup.string().nullable().max(2000, "Caractère maximale 2000"),
  });

  return (
    <>
      <ModalAlert
        closeModal={handleVisibility}
        show={visible}
        title={
          <ModalTitle>
            {" "}
            Joindre un fichier modèle de lettre de mission
          </ModalTitle>
        }
        footer={[]}
        modalStyles={{ top: 30 }}
        width={600}
      >
        <Formik
          initialValues={{
            selectedFiles: null,
            libelle: data.libelle || "",
            reference: data.reference || "",
            description: data.description || "",
            client_id: (client && client.id) || "",
          }}
          onSubmit={(values) => handleUploadUpdate(values)}
          validationSchema={dataValidationScheme}
        >
          {({ values, handleSubmit, setFieldValue, touched, errors }) => (
            <Form>
              <Row gutter={[16, 16]}>
                <Col span={20}>
                  <FormLabel label="Fichier" required />
                  <div className="row fv-row mb-7 fv-plugins-icon-container">
                    <div className="d-flex align-center">
                      <div className="">
                        <div className="d-flex align-items-center mb-3">
                          <input
                            id="fileInput" // 🔹 Ajoute un ID pour le cibler dans le bouton
                            type="file"
                            style={{ width: "100%" }}
                            className="form-control w-lg-400px"
                            //accept=".xlsx, .csv, .xls"
                            onChange={(event) => {
                              const file = event.target.files[0]; // Un seul fichier au lieu d'un tableau
                              setFieldValue("selectedFiles", file);
                            }}
                            required={true}
                          />
                        </div>
                        <span className="form-text fs-6 text-muted">
                          Taille maximale de fichier 10MB.
                        </span>{" "}
                        <br />
                        {touched.reference && errors.reference && (
                          <FormError fieldName="selectedFiles" />
                        )}
                      </div>
                    </div>

                    <div className="dropzone-items">
                      {values.selectedFiles && values.selectedFiles.name && (
                        <div className="m-6">
                          {getIconForFileType(values.selectedFiles.name)}{" "}
                          {values.selectedFiles.name}
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
                <Col span={4}>
                  <div className="pt-10">
                    <button
                      type="button"
                      className="dropzone-remove-all btn btn-sm btn-light-primary"
                      onClick={() => {
                        setFieldValue("selectedFiles", null);

                        // 🔥 Réinitialise l'input fichier pour permettre une nouvelle sélection
                        document.getElementById("fileInput").value = "";
                      }}
                    >
                      <DeleteFilled
                        style={{ color: "red", fontSize: "15px" }}
                      />
                    </button>
                  </div>
                </Col>
                <Col span={24}>
                  <FormLabel label="Reférence" required />
                  <Input
                    size="large"
                    placeholder="Saisir la reférence"
                    name="reference"
                    value={values.reference}
                    onChange={(e) => setFieldValue("reference", e.target.value)}
                  />
                  {touched.reference && errors.reference && (
                    <FormError fieldName="reference" />
                  )}
                </Col>
                <Col span={24}>
                  <FormLabel label="Nom du fichier" required />
                  <Input
                    size="large"
                    placeholder="Le nom du fichier"
                    name="libelle"
                    value={values.libelle}
                    onChange={(e) => setFieldValue("libelle", e.target.value)}
                  />
                  {touched.libelle && errors.libelle && (
                    <FormError fieldName="libelle" />
                  )}
                </Col>
                <Col span={24}>
                  <FormLabel label="Note" />
                  <Input.TextArea
                    size="large"
                    placeholder="Message"
                    name="description"
                    value={values.description}
                    onChange={(e) =>
                      setFieldValue("description", e.target.value)
                    }
                    showCount
                    maxLength={2000}
                    rows={2}
                  />
                  {touched.description && errors.description && (
                    <FormError fieldName="notes" />
                  )}
                </Col>
                <Col span={24}>
                  <Button
                    type="primary"
                    block
                    size="large"
                    loading={loadingCreate}
                    disabled={loadingCreate}
                    onClick={handleSubmit}
                  >
                    {!loadingCreate && (
                      <span className="indicator-label">Enregistrer</span>
                    )}
                    {loadingCreate && (
                      <span className="indicator-progress text-white">
                        Veuillez patienter...
                        <span className="spinner-border spinner-border-sm align-middle ms-2 text-white"></span>
                      </span>
                    )}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </ModalAlert>
    </>
  );
};

export default FileUpdateUploaderModeleLN;
